<template>
  <div class="connection-status" data-cy="connection-status" v-if="showStatus">
    <span class="label" data-cy="connection-status-label" v-on:click="handleStatusTap">{{ statusLabel }}</span>
    <button v-if="canReconnect" class="reconnect" data-cy="connection-reconnect" v-on:click="reconnect">Reconnect</button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      statusTapTimer: null,
      statusTapThresholdMs: 250,
    }
  },
  computed: {
    ...mapGetters('NetworkInterface', [
      'connectionStatus',
      'session',
    ]),
    showStatus() {
      if (this.connectionStatus === 'connecting') {
        return true
      }

      return this.session && (this.session.isController() || this.session.isScreen())
    },
    canReconnect() {
      return this.connectionStatus === 'disconnected'
    },
    statusLabel() {
      switch (this.connectionStatus) {
        case 'connected':
          return 'Connected'
        case 'connecting':
          return 'Connecting...'
        default:
          return 'Disconnected'
      }
    },
  },
  methods: {
    clearStatusTapTimer() {
      if (this.statusTapTimer) {
        clearTimeout(this.statusTapTimer)
        this.statusTapTimer = null
      }
    },
    handleStatusTap() {
      if (this.statusTapTimer) {
        this.clearStatusTapTimer()
        this.$store.dispatch('NetworkInterface/setNetworkMetricsVisible', true)
        return
      }

      this.statusTapTimer = setTimeout(() => {
        this.statusTapTimer = null
        this.$store.dispatch('NetworkInterface/setNetworkMetricsVisible', false)
      }, this.statusTapThresholdMs)
    },
    reconnect() {
      this.$store.dispatch('NetworkInterface/reconnect')
    },
  },
  beforeDestroy() {
    this.clearStatusTapTimer()
  },
}
</script>

<style lang="scss" scoped>
@import './../../../colors.scss';

.connection-status {
  position: fixed;
  right: 10px;
  top: 10px;
  z-index: 10001;
  border: 1px solid $main;
  background: rgba(var(--theme-bg-rgb), 0.9);
  padding: 6px 10px;
  font-family: var(--theme-control-font);
  font-size: 24px;
  display: flex;
  align-items: center;
  gap: 8px;

  .reconnect {
    min-width: 90px;
    margin: 0;
    padding: 4px 8px;
    font-size: 0.9em;
  }

  .label {
    cursor: pointer;
    user-select: none;
    touch-action: manipulation;
  }
}
</style>
